
import React from "react";

interface ErrorDisplayProps {
  error: string;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error }) => {
  if (!error) return null;

  return (
    <div className={`text-xs md:text-sm p-3 md:p-5 rounded-lg md:rounded-xl border font-medium ${
      error.includes("successfully") 
        ? "bg-green-50 text-green-800 border-green-200 dark:bg-green-950/30 dark:text-green-400 dark:border-green-800" 
        : "bg-red-50 text-red-800 border-red-200 dark:bg-red-950/30 dark:text-red-400 dark:border-red-800"
    }`}>
      {error}
    </div>
  );
};

export default ErrorDisplay;
